import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import EmailList from './pages/EmailList';
import EmailDetail from './pages/EmailDetail';
import Analytics from './pages/Analytics';
import Insights from './pages/Insights';
import ChatBot from './pages/ChatBot';
import Login from './components/Login';
import Register from './components/Register';
import PromptManager from './pages/PromptManager';
import AdminPromptManager from './pages/AdminPromptManager';
import AdminSettings from './pages/AdminSettings';
import EmailImport from './pages/EmailImport';
import WhatsAppList from './pages/WhatsAppList';
import WhatsAppDetail from './pages/WhatsAppDetail';
import WhatsAppMonitoring from './pages/WhatsAppMonitoring';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Navbar />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/" element={
              <ProtectedRoute>
                <Home />
              </ProtectedRoute>
            } />
            <Route path="/emails" element={
              <ProtectedRoute>
                <EmailList />
              </ProtectedRoute>
            } />
            <Route path="/whatsapp" element={
              <ProtectedRoute>
                <WhatsAppList />
              </ProtectedRoute>
            } />
            <Route path="/whatsapp/:id" element={
              <ProtectedRoute>
                <WhatsAppDetail />
              </ProtectedRoute>
            } />
            <Route path="/import" element={
              <ProtectedRoute>
                <EmailImport />
              </ProtectedRoute>
            } />
            <Route path="/emails/import" element={<Navigate to="/import" replace />} />
            <Route path="/emails/:id" element={
              <ProtectedRoute>
                <EmailDetail />
              </ProtectedRoute>
            } />
            <Route path="/analytics" element={
              <ProtectedRoute>
                <Analytics />
              </ProtectedRoute>
            } />
            <Route path="/insights" element={
              <ProtectedRoute>
                <Insights />
              </ProtectedRoute>
            } />
            <Route path="/chatbot" element={
              <ProtectedRoute>
                <ChatBot />
              </ProtectedRoute>
            } />
            <Route path="/prompts" element={
              <ProtectedRoute>
                <PromptManager />
              </ProtectedRoute>
            } />
            <Route path="/admin/prompts" element={
              <ProtectedRoute>
                <AdminPromptManager />
              </ProtectedRoute>
            } />
            <Route path="/admin/whatsapp-monitoring" element={
              <ProtectedRoute>
                <WhatsAppMonitoring />
              </ProtectedRoute>
            } />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App; 